module.exports = __webpack_public_path__ + "static/media/Pelvis v1.9d185482.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Pelvis v1.png
// module id = 1179
// module chunks = 0